var _circle, _path, _path2, _path3, _path4, _path5, _rect, _path6, _ellipse, _ellipse2, _ellipse3, _path7, _path8, _path9, _polygon, _path10, _polygon2, _path11, _path12, _circle2, _path13, _path14, _circle3, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 634.30979,
    height: 664.89511,
    viewBox: "0 0 634.30979 664.89511",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 428.96615,
    cy: 433.53675,
    r: 13.08937,
    fill: "#1db954"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M822.13393,580.0736H702.61983a3.89775,3.89775,0,1,1,0-7.7955h119.5141a3.89775,3.89775,0,1,1,0,7.7955Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M732.3035,595.47555H702.61983a3.89794,3.89794,0,1,1,0-7.79588H732.3035a3.89794,3.89794,0,1,1,0,7.79588Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M729.22291,459.6466H461.21277a8.07557,8.07557,0,0,1-8.06636-8.06636V246.71265a8.07531,8.07531,0,0,1,8.06636-8.066H729.22291a8.07531,8.07531,0,0,1,8.06635,8.066V451.58024A8.07557,8.07557,0,0,1,729.22291,459.6466Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M729.22272,460.6466H461.213a9.077,9.077,0,0,1-9.0664-9.06641V246.71251a9.07652,9.07652,0,0,1,9.0664-9.06591H729.22272a9.07653,9.07653,0,0,1,9.06641,9.06591V451.58019A9.077,9.077,0,0,1,729.22272,460.6466Zm-268.00977-221a7.07423,7.07423,0,0,0-7.0664,7.06591V451.58019a7.07434,7.07434,0,0,0,7.0664,7.06641H729.22272a7.07435,7.07435,0,0,0,7.06641-7.06641V246.71251a7.07424,7.07424,0,0,0-7.06641-7.06591Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#f0f0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M453.76546,420.6466v30.93379a7.45828,7.45828,0,0,0,7.44716,7.44716H729.22306a7.45828,7.45828,0,0,0,7.44716-7.44716V420.6466Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#f0f0f0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 595.21119,
    y: 163.94027,
    width: 1.99962,
    height: 333.55961,
    transform: "translate(-286.6331 536.9647) rotate(-57.37135)",
    fill: "#f0f0f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M916.16168,154.10493H283.83832a1.01559,1.01559,0,0,1,0-2.03069H916.16168a1.01559,1.01559,0,0,1,0,2.03069Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.34831,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.09038,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.83246,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M893.54466,120.32075h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M893.54466,127.94074h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M893.54466,135.55073h-26.81a2.0304,2.0304,0,0,0,0,4.06h26.81a2.0304,2.0304,0,0,0,0-4.06Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "347.518 650.023 360.408 650.022 366.54 600.305 347.516 600.306 347.518 650.023",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M627.07552,763.367l3.628-.00015,14.16443-5.76035,7.59171,5.75947h.001a16.17765,16.17765,0,0,1,16.17679,16.17653v.52568l-41.56122.00154Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.053 633.265 242.589 639.014 270.256 597.254 253.229 588.768 231.053 633.265",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M512.83262,745.58411l3.24711,1.61832,15.24662,1.16328,4.22518,8.54127.00092.00046a16.17765,16.17765,0,0,1,7.26169,21.69415l-.23451.47048-37.19735-18.53893Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M636.07424,541.77869l-81.95531,2.138,1.42531,39.90868s-1.42531,10.68982,1.42531,13.54044,4.27593,2.85062,2.85062,7.8392S554.71,657.85786,554.71,657.85786s-33.63678,59.47561-32.21147,60.90092,2.85062,0,1.42531,3.56328-2.85062,2.138-1.42531,3.56327a52.48759,52.48759,0,0,1,3.56328,4.27593h23.23s1.29906-7.12655,1.29906-7.8392,1.4253-4.98859,1.4253-5.70124,40.58611-43.71363,40.58611-43.71363l8.55186-71.26549,20.667,69.84018s0,61.28832,1.42531,62.71363,1.42531.71265.71266,3.56327-3.56328,2.138-1.42531,4.27593,2.85062-1.42531,2.138,2.138l-.71265,3.56327,27.37964.30583s2.85062-6.00707,1.42531-8.145-1.33979-1.55437.39909-5.05312,2.45153-4.21139,1.73888-4.924-.71266-4.50319-.71266-4.50319-10.27593-140.16575-10.27593-142.30372a7.10838,7.10838,0,0,1,.592-3.20606v-2.902l-2.73-10.283Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.68558,
    cy: 217.92747,
    r: 53.64177,
    fill: "#1db954"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M592.214,360.57507a4.50007,4.50007,0,0,1-2.1709-.56543,4.44151,4.44151,0,0,1-2.333-3.94385V318.892a4.49981,4.49981,0,0,1,6.9126-3.79834l35.26318,18.58691a4.50008,4.50008,0,0,1,0,7.59668l-35.26318,18.58691A4.47852,4.47852,0,0,1,592.214,360.57507Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M610.65639,406.86111s-27.39828-2.73982-29.22484,0a15.693,15.693,0,0,0-1.82656,7.30618s-10.9593,4.56637-12.78586,2.73981-3.65312-7.30618-9.1328-5.47967S541.71,444.85786,541.71,444.85786s1,0,6.8435,29.58562c3.942,19.95818,3.28993,36.34929,3.72237,47.51069.07125,1.839-2.61732,8.33964-2.56587,9.90369.22921,6.968,3.05683,6.36909,3.40987,7.42823.91325,2.73981-4.56637,19.17879,28.31153,19.17879s56.62318-1.8265,56.62318-8.21943c0-3.22372,3.33428-5.11157,2.65542-15.38759-.18634-2.82066-5.0465-12.44739-5.08158-15.45081a110.5326,110.5326,0,0,1,.43335-11.61657,67.92559,67.92559,0,0,1,1.99281-11.4284c5.47962-20.0922,7.65542-56.50422,7.65542-56.50422l-9-18-19.66083-3.1242S616.13607,407.77436,610.65639,406.86111Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "f9362fdd-3f27-4fec-a8e4-b8d11fe473ca",
    "data-name": "ab6171fa-7d69-4734-b81c-8dff60f9761b",
    cx: 596.51758,
    cy: 377.60805,
    r: 23.72181,
    transform: "translate(-360.94814 51.94964) rotate(-15.19079)",
    fill: "#ffb6b6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M709.95291,740.79142l.70716-15.90017a51.3527,51.3527,0,0,1,23.9526-6.06333c-11.504,9.40539-10.06637,27.53575-17.86583,40.18378a30.8888,30.8888,0,0,1-22.65105,14.27412l-9.627,5.89429a51.75975,51.75975,0,0,1,10.90965-41.9429,49.99669,49.99669,0,0,1,9.1885-8.53763C706.87265,734.77919,709.95291,740.79142,709.95291,740.79142Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M837.59547,780.89434a1.54861,1.54861,0,0,1-1.5533,1.55322H417.992a1.55322,1.55322,0,0,1,0-3.10644H836.04217A1.54866,1.54866,0,0,1,837.59547,780.89434Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M705.39809,546.09314a7.483,7.483,0,0,1-7.52827-8.65934l-41.5299-22.73929,12.15482-6.57378,38.48558,23.11419a7.52355,7.52355,0,0,1-1.58223,14.85822Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M690.2491,534.28435l-31.72691-11.6159-14.27309-13.3841-3.54647-1.80632L628.47992,498.899l-.03644-.10815-19.42136-57.4096a18.80383,18.80383,0,0,1,13.91456-21.73705h0a18.78362,18.78362,0,0,1,23.1684,15.86033l6.25027,49.20255L670.716,501.40661l4.53314.87774,1.04347,4.88131,20.95653,15.11869Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M565.84355,305.80535a7.483,7.483,0,0,1-8.62167,7.57137l-22.53182,41.64283-6.63434-12.12187,22.9219-38.60042a7.52355,7.52355,0,0,1,14.86593,1.50809Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M569.02419,421.88517,554.8961,401.32754s2.22128.13068.81394-4.46968c-.38308-1.25224-4.07807-5.57294-4.49726-7.07092-.36946-1.32028-.74728-2.7281-1.12348-4.20952-1.34891-5.31193-8.63657-10.22344-7.37926-16.71956,6-31,9-37,9.92068-41.96571,0,0-5.21634-19.33855-13.68264-7.39373s-21.88513,42.30511-18.33332,57.39144,17.129,64.30159,21.308,67.96187S569.02419,421.88517,569.02419,421.88517Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M613.727,349.54835c-1.75666-.05218-1.15363-3.36334-2.56891-4.41962q-.01035.04807-.02142.09595a3.44963,3.44963,0,0,1-6.59229.28125,5.24288,5.24288,0,0,0-3.3288-3.49219c-.08813,3.069-2.4096,5.73267-5.17907,7.05823s-5.92725,1.54614-8.99726,1.59155a39.70992,39.70992,0,0,0-9.16125.69385c-2.977.75122-5.87268,2.51752-7.14459,5.312-1.272,2.7945-.36444,6.64191,2.41681,7.94251-2.15461.01147-3.98285,1.78943-4.72785,3.81116a15.13305,15.13305,0,0,0-.46716,6.39465c.60553,7.92572,2.08185,16.45868,7.85309,21.92462,4.39849,4.16583,10.69427,5.844,16.75232,5.81976,6.058-.02429,4.99285-.58111,10.85034-2.12732,0,0,5.56885-15.96453,4.16656-17.535-1.40228-1.57043-2.567-3.58008-2.31323-5.67017s2.49994-3.9624,4.44922-3.16674c-.32776-.8379-.57471-.9975-.72937-.955a7.40881,7.40881,0,0,0,.25757-.72833,8.28842,8.28842,0,0,1,5.17633-5.48908,6.42778,6.42778,0,0,1,7.02551,2.12616C627.85744,363.00129,623.87825,349.8498,613.727,349.54835Z",
    transform: "translate(-282.84511 -117.55244)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPlayer);
export default __webpack_public_path__ + "static/media/media-player.b7390d456c5d232b6d62b9b5d7a6d91b.svg";
export { ForwardRef as ReactComponent };